<p-dialog
  [(visible)]="displayModal"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="true"
  styleClass="order-dialog">
  <ng-template pTemplate="header">
    <div class="header-modal pb-4 has-border w-100 d-flex align-items-center">
      <h2 class="me-2">Invoice PDF</h2>
    </div>
  </ng-template>

  <div *ngFor="let item of invoiceList">
    <a class="link" (click)="getProjectInvoiceReport(item)">{{
      item.ProjectInvoiceId
    }}</a>
  </div>

  <ng-template pTemplate="footer">
    <div class="d-flex pt-2 justify-content-end">
      <button
        type="button"
        (click)="closeModalDialog()"
        class="btn btn-secondary me-3">
        Cancel
      </button>
    </div>
  </ng-template>
</p-dialog>
